// ABOUTME: Shared date-range formatter for analytics chat cards (#2342).
// A date-only ISO string ("2026-08-01") parses as UTC midnight; formatting it
// with the browser's LOCAL zone then renders one calendar day early for any
// timezone west of UTC (e.g. America/Chicago). Every caller must format in
// UTC to avoid that round-trip shift — do not reintroduce a per-card copy.

/** Format a single date-only ISO string ("2026-08-01") as "Aug 1", in UTC. */
function formatShortDate(isoDate: string): string {
  return new Date(isoDate).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  })
}

/** Format an ISO date range as "Aug 1 - Aug 12", both ends read in UTC. */
export function formatDateRange(start: string, end: string): string {
  return `${formatShortDate(start)} - ${formatShortDate(end)}`
}
